import { MobileQuick } from './mobile-quick'
import { Quick } from './quick'

export const Telephony = {
  Quick,
  MobileQuick
}
